import type * as React from "react"

import { cn } from "~/lib/utils"
import { formInputSurface } from "./input"

function Textarea({
	className,
	variant = "default",
	...props
}: React.ComponentProps<"textarea"> & {
	variant?: "default" | "document" | "summary" | "group" | "form"
}) {
	return (
		<textarea
			data-slot="textarea"
			className={cn(
				"placeholder:text-muted-foreground flex field-sizing-content w-full rounded-md transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50",
				variant === "form" && [formInputSurface, "min-h-24 resize-none"],
				variant === "default" &&
					"min-h-16 surface-recessed bg-background-tertiary px-3 py-3 sm:py-2 text-base sm:text-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
				(variant === "document" || variant === "summary") &&
					"resize-none bg-transparent px-1 leading-6 focus-visible:outline-1 outline-ring",
				variant === "document" && "min-h-52 text-base",
				variant === "summary" && "min-h-10 text-sm",
				variant === "group" &&
					"min-h-16 flex-1 resize-none rounded-none border-0 bg-transparent px-3 py-3 text-base sm:text-sm",
				className
			)}
			{...props}
		/>
	)
}

export { Textarea }
